import { createSvgIcon } from "@mui/material";

export const GrandCycleDeEauIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="5" fill="#93D4C4" />
    <path
      d="M3.66667 16.2709C5.33333 15.0209 7 15.0209 9.5 16.2709C12 17.5209 14.9167 16.2708 14.9167 16.2708C18.6667 14.6042 20.3333 16.2708 20.3333 16.2708"
      stroke="#F1F2F3"
      strokeWidth="0.666667"
      strokeLinecap="round"
    />
    <path
      d="M3.66666 17.764C5.33333 16.5141 7 16.514 9.5 17.764C12 19.014 14.9167 17.764 14.9167 17.764C18.6667 16.0974 20.3333 17.764 20.3333 17.764"
      stroke="#F1F2F3"
      strokeWidth="0.666667"
      strokeLinecap="round"
    />
    <path
      d="M3.66666 19.2571C5.33333 18.0071 7 18.0071 9.5 19.2571C12 20.5071 14.9167 19.257 14.9167 19.257C18.6667 17.5904 20.3333 19.257 20.3333 19.257"
      stroke="#F1F2F3"
      strokeWidth="0.666667"
      strokeLinecap="round"
    />
    <path
      d="M15.9771 4.84C14.9076 10.3899 13.1122 11.2815 8.62667 10.4902C11.6441 6.1192 13.2383 4.74957 15.9771 4.84Z"
      fill="white"
    />
    <path
      d="M15.9771 4.84C14.9076 10.3899 13.1122 11.2815 8.62667 10.4902C11.6441 6.1192 13.2383 4.74957 15.9771 4.84Z"
      stroke="white"
    />
    <path
      d="M19.2657 7.87225C18.2651 10.2135 17.1965 11.5735 15.6887 12.0563C14.2031 12.5319 12.3859 12.1198 9.99234 11.2124L9.47582 11.0174L9.90917 10.6742L10.6287 10.1152C12.2587 8.86919 13.5647 8.03864 14.792 7.58645C16.2136 7.06275 17.5123 7.05169 19.0551 7.44558L19.409 7.53619L19.2657 7.87225Z"
      fill="white"
      stroke="#93D4C4"
      strokeWidth="0.626126"
      strokeLinecap="round"
    />
    <path
      d="M7.58171 10.25C9.08736 10.1183 12.5229 11.8366 13.0063 14.018"
      stroke="white"
      strokeWidth="1.25225"
      strokeLinecap="round"
    />
  </svg>,
  "GrandCycleDeEauIcon"
);
